export default "__VITE_ASSET__CrimPQ_H__"